import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ImageAvatar = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4.08333 17.6249V16.0624C4.08333 14.9118 5.01607 13.9791 6.16667 13.9791H14.5C15.6506 13.9791 16.5833 14.9118 16.5833 16.0624V18.1457M4.08333 18.6667C2.93274 18.6667 2 17.6848 2 16.4737V4.19298C2 2.98183 2.93274 2 4.08333 2H16.5833C17.7339 2 18.6667 2.98183 18.6667 4.19298V16.4737C18.6667 17.6848 17.7339 18.6667 16.5833 18.6667H4.08333ZM12.9375 7.72906C12.9375 9.16731 11.7716 10.3332 10.3333 10.3332C8.89509 10.3332 7.72917 9.16731 7.72917 7.72906C7.72917 6.29082 8.89509 5.1249 10.3333 5.1249C11.7716 5.1249 12.9375 6.29082 12.9375 7.72906Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ImageAvatar
